import React from 'react'
import PropTypes from 'prop-types'

import { Dots, Heading, WantSeeDemoButton } from 'Components/Blocks/_Legacy'
import AnimatedScrollBox from 'Components/Blocks/_Legacy/AnimatedScrollBox'
import { Motion, Wrapper } from 'Components/UI'

import solutionGlyph from 'Assets/_Legacy/Svg/solution.svg'

import {
  ButtonWrapper,
  Container,
  Content,
  DotsContainer,
  ImageHolder,
  LeftContainer,
} from './styles'

import { SEQUENCES } from '../sequences'

function What({ data }) {
  return (
    <Container>
      <Wrapper>
        <Content>
          <LeftContainer flexDirection="column" width={100}>
            <Motion>
              <Heading
                fontSie={{ title: [28, 28, 40], sub: [14, 14, 16] }}
                horizontalAlign="left"
                subTitleText={data.subtitleText}
                tagGlyph={solutionGlyph}
                tagText={data.overheadText}
                titleText={{
                  first: {
                    text: data.titleTextFirst,
                    bold: data.firstBold,
                  },
                  second: {
                    text: data.titleTextSecond,
                    bold: data.secondBold,
                  },
                }}
                verticalAlign="center"
              />
            </Motion>

            <Motion>
              <ButtonWrapper>
                <WantSeeDemoButton width="250px" />
              </ButtonWrapper>
            </Motion>
          </LeftContainer>

          <ImageHolder>
            <AnimatedScrollBox sequence={SEQUENCES.what} />
          </ImageHolder>

          <DotsContainer>
            <Dots
              columns={17}
              corners={[true, true, true, false]}
              margin={4}
              rows={17}
            />
          </DotsContainer>
        </Content>
      </Wrapper>
    </Container>
  )
}

What.defaultProps = {
  data: {},
}

What.propTypes = {
  data: PropTypes.object,
}

export default What
